import {
  PULSE_CLICK_ACTION,
  trackPaymentPageClick,
} from './pulseClickIds';
import type { CheckoutPaymentModalKind } from './pulseCheckoutPaymentViews';

/** Tap on checkout Add/Edit credit or gift card buttons (skipped for split-payment sub-flow). */
export function trackCheckoutPaymentMethodButtonClick(params: {
  kind: CheckoutPaymentModalKind;
  hasSelectedCard: boolean;
  isSplitPaymentWithCards: boolean;
  pagePath?: string;
}): void {
  if (params.isSplitPaymentWithCards) return;

  const action =
    params.kind === 'credit'
      ? params.hasSelectedCard
        ? PULSE_CLICK_ACTION.TAP_EDIT_CREDIT_CARD
        : PULSE_CLICK_ACTION.TAP_ADD_CREDIT_CARD
      : params.hasSelectedCard
        ? PULSE_CLICK_ACTION.TAP_EDIT_GIFT_CARD
        : PULSE_CLICK_ACTION.TAP_ADD_GIFT_CARD;

  trackPaymentPageClick({
    action,
    label: null,
    page_path: params.pagePath,
  });
}

/** Tap on Express Checkout wallet button (Apple Pay / Google Pay). */
export function trackExpressCheckoutWalletTap(params: {
  expressPaymentType: string;
  pagePath?: string;
}): void {
  const action =
    params.expressPaymentType === 'apple_pay'
      ? PULSE_CLICK_ACTION.TAP_APPLE_PAY
      : params.expressPaymentType === 'google_pay'
        ? PULSE_CLICK_ACTION.TAP_GOOGLE_PAY
        : null;
  if (!action) return;

  trackPaymentPageClick({
    action,
    label: null,
    page_path: params.pagePath ?? window.location.pathname,
  });
}
